export default function ConfirmDeleteModal({
                                               open,
                                               setOpen,
                                               title = "Confirm",
                                               message = "Are you sure?",
                                               confirmText = "Confirm",
                                               cancelText = "Cancel",
                                               onConfirm,
                                           }) {
    if (!open) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={() => setOpen(false)}
        >
            <div
                className="bg-white rounded-lg p-6 max-w-lg w-full mx-4"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-serif font-bold text-gray-900">{title}</h2>
                    <button onClick={() => setOpen(false)} className="text-gray-400 hover:text-gray-600">
                        <i className="fa-solid fa-times text-xl" />
                    </button>
                </div>

                <p className="text-gray-700 mb-6">{message}</p>

                <div className="flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-opacity-90"
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
